(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle-topbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-lt-bar]').forEach(initBar);
  }

  function initBar(bar) {
    if (bar.dataset.ltInit === '1') return;
    bar.dataset.ltInit = '1';

    // Expose topbar height as CSS var for the header section to stack below
    function updateHeight() {
      const h = bar.offsetHeight;
      document.documentElement.style.setProperty('--lt-topbar-h', h + 'px');
    }
    updateHeight();
    window.addEventListener('resize', updateHeight);

    const countdown = bar.querySelector('[data-countdown]');
    if (!countdown) return;

    const mode = bar.dataset.countdownMode || 'fixed';
    let endTime;

    if (mode === 'session') {
      const minutes = parseInt(bar.dataset.sessionMinutes || '30', 10);
      const key = 'lt_countdown_end_' + bar.dataset.shopifyEditorBlockId || 'lt_countdown_end';
      const stored = localStorage.getItem(key);
      const now = Date.now();
      if (stored && parseInt(stored, 10) > now) {
        endTime = parseInt(stored, 10);
      } else {
        endTime = now + minutes * 60 * 1000;
        try { localStorage.setItem(key, endTime); } catch (_) {}
      }
    } else {
      const dateStr = (bar.dataset.endDate || '').trim();
      if (!dateStr) return;
      endTime = new Date(dateStr.replace(' ', 'T')).getTime();
      if (isNaN(endTime)) return;
    }

    const daysEl = countdown.querySelector('[data-days]');
    const hoursEl = countdown.querySelector('[data-hours]');
    const minutesEl = countdown.querySelector('[data-minutes]');
    const secondsEl = countdown.querySelector('[data-seconds]');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      const diff = Math.max(0, endTime - Date.now());
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff / 3600000) % 24);
      const m = Math.floor((diff / 60000) % 60);
      const s = Math.floor((diff / 1000) % 60);
      if (daysEl) daysEl.textContent = pad(d);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minutesEl) minutesEl.textContent = pad(m);
      if (secondsEl) secondsEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-progress"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    const bars = document.querySelectorAll('[data-progress]');
    if (!bars.length) return;

    let ticking = false;

    function update() {
      const doc = document.documentElement;
      const scrollable = (doc.scrollHeight - window.innerHeight) || 1;
      const ratio = Math.max(0, Math.min(1, window.scrollY / scrollable));
      bars.forEach(bar => {
        const fill = bar.querySelector('.sp__fill');
        if (fill) fill.style.transform = 'scaleX(' + ratio + ')';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAll(scope) {
    const root = scope || document;
    const wraps = root.classList && root.classList.contains('vg-wrap')
      ? [root]
      : root.querySelectorAll('.vg-wrap');
    wraps.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Theme editor: re-init when section is reloaded or block is selected
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('shopify:section:select', e => initAll(e.target));
  document.addEventListener('shopify:block:select', e => initAll(e.target));

  function initSection(wrap) {
    if (wrap.dataset.vgInit === '1') return;
    wrap.dataset.vgInit = '1';

    const afterAdd = wrap.dataset.afterAdd || 'drawer';
    const cards = wrap.querySelectorAll('.vg-card:not(.vg-card--placeholder):not(.vg-card--image)');

    cards.forEach(card => {
      const sizeSelect = card.querySelector('.vg-size-select');
      const genderSelect = card.querySelector('.vg-gender-select');
      const atc = card.querySelector('.vg-card__atc');
      const atcLabel = atc ? atc.querySelector('.vg-card__atc-label') : null;
      const hover = card.querySelector('.vg-card__img--hover');
      const media = card.querySelector('.vg-card__media');

      if (hover && media) {
        let lastTap = 0;
        media.addEventListener('touchstart', () => {
          if (window.matchMedia('(hover: none)').matches) {
            const now = Date.now();
            if (now - lastTap < 350) return;
            lastTap = now;
            card.dataset.showHover = card.dataset.showHover === 'true' ? 'false' : 'true';
          }
        }, { passive: true });
      }

      if (sizeSelect && atc) {
        sizeSelect.addEventListener('change', () => {
          if (sizeSelect.value) {
            atc.dataset.variantId = sizeSelect.value;
            hideError(card);
          } else {
            delete atc.dataset.variantId;
          }
        });
      }

      if (genderSelect && sizeSelect) {
        const updateLabels = () => {
          const gender = genderSelect.value === 'men' ? 'men' : 'women';
          sizeSelect.dataset.gender = gender;
          const soldOutLabel = sizeSelect.dataset.soldOutLabel || 'Sold out';
          [...sizeSelect.options].forEach(opt => {
            if (!opt.value) return;
            const next = gender === 'men' ? opt.dataset.sizeMen : opt.dataset.sizeWomen;
            if (next) {
              const newText = opt.disabled ? `${next} — ${soldOutLabel}` : next;
              opt.textContent = newText;
              opt.text = newText;
            }
          });
        };
        genderSelect.addEventListener('change', updateLabels);
        genderSelect.addEventListener('input', updateLabels);
        updateLabels();
      }

      if (atc) {
        atc.addEventListener('click', async () => {
          const variantId = atc.dataset.variantId;
          if (!variantId) {
            showError(card);
            return;
          }

          const original = atc.dataset.defaultLabel;
          const wasDisabled = atc.disabled;
          atc.disabled = true;
          if (atcLabel) atcLabel.textContent = '...';

          try {
            // Ask Shopify to also render the cart-drawer + cart-icon-bubble sections
            // so we can update them in place (Dawn-style flow)
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(variantId), quantity: 1 }],
                sections: 'cart-drawer,cart-icon-bubble',
                sections_url: window.location.pathname
              })
            });
            if (!res.ok) {
              const err = await res.json().catch(() => ({}));
              throw new Error(err.description || err.message || 'Add to cart failed');
            }
            const data = await res.json();

            atc.classList.add('vg-card__atc--success');
            if (atcLabel) atcLabel.textContent = atc.dataset.addedLabel || 'Added';

            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('product:added-to-cart', { bubbles: true }));

            // Refresh the cart icon bubble (if Shopify rendered it)
            if (data.sections && data.sections['cart-icon-bubble']) {
              const bubble = document.getElementById('cart-icon-bubble');
              if (bubble) bubble.innerHTML = getInnerHTMLFrom(data.sections['cart-icon-bubble'], '#cart-icon-bubble');
            }

            try {
              const cartRes = await fetch('/cart.js');
              const cart = await cartRes.json();
              document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count').forEach(el => {
                el.textContent = cart.item_count;
              });
            } catch (_) {}

            if (afterAdd === 'redirect') {
              window.location.href = '/cart';
              return;
            }
            if (afterAdd === 'drawer') {
              openDawnDrawerOrFallback(wrap, data);
            }

            setTimeout(() => {
              atc.classList.remove('vg-card__atc--success');
              if (atcLabel) atcLabel.textContent = original;
              atc.disabled = false;
            }, 1600);
          } catch (e) {
            console.error('[Variant Grid] add to cart error:', e);
            atc.classList.add('vg-card__atc--error');
            if (atcLabel) atcLabel.textContent = 'Try again';
            setTimeout(() => {
              atc.classList.remove('vg-card__atc--error');
              if (atcLabel) atcLabel.textContent = original;
              atc.disabled = false;
            }, 2000);
          }
        });
      }
    });
  }

  function showError(card, msg) {
    const err = card.querySelector('.vg-card__error');
    if (err) {
      if (msg) err.textContent = msg;
      err.classList.add('vg-card__error--show');
    }

    const sizeSelect = card.querySelector('.vg-size-select');
    if (sizeSelect) {
      sizeSelect.classList.remove('vg-size-select--shake');
      void sizeSelect.offsetWidth;
      sizeSelect.classList.add('vg-size-select--shake');
      setTimeout(() => sizeSelect.classList.remove('vg-size-select--shake'), 500);
    }

    clearTimeout(card._vgErrTimeout);
    card._vgErrTimeout = setTimeout(() => {
      if (err) err.classList.remove('vg-card__error--show');
    }, 2800);
  }

  function hideError(card) {
    const err = card.querySelector('.vg-card__error');
    if (err) err.classList.remove('vg-card__error--show');
    clearTimeout(card._vgErrTimeout);
  }

  function getInnerHTMLFrom(html, selector) {
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector(selector);
      return el ? el.innerHTML : html;
    } catch (_) {
      return html;
    }
  }

  function openDawnDrawerOrFallback(wrap, data) {
    // Dawn-style: <cart-drawer> custom element with renderContents() and open()
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // Use Dawn's own renderContents if available (handles full update + open)
      if (typeof cartDrawer.renderContents === 'function' && data) {
        try {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
          return;
        } catch (e) {
          console.warn('[Variant Grid] renderContents failed, falling back', e);
        }
      }
      // Manual update: replace cart-drawer section HTML and call open()
      if (data && data.sections && data.sections['cart-drawer']) {
        const sectionEl = document.getElementById('shopify-section-cart-drawer');
        if (sectionEl) {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = data.sections['cart-drawer'];
          const newSection = wrapper.querySelector('#shopify-section-cart-drawer') || wrapper.firstElementChild;
          if (newSection) {
            sectionEl.replaceWith(newSection);
          }
        }
      }
      // Re-query in case we replaced
      const cd = document.querySelector('cart-drawer');
      if (cd && typeof cd.open === 'function') {
        cd.classList.remove('is-empty');
        cd.open();
        return;
      }
    }
    // Generic fallback for non-Dawn themes
    tryOpenCartDrawer(wrap);
  }

  function tryOpenCartDrawer(wrap) {
    // 0. Custom selector from section settings — highest priority
    const custom = wrap && wrap.dataset.drawerSelector;
    if (custom && custom.trim() !== '') {
      try {
        const el = document.querySelector(custom);
        if (el) {
          safeClick(el);
          return;
        }
      } catch (_) {}
    }

    // 1. Dispatch every event name a Shopify theme might listen for
    const events = [
      'cart:open', 'cart-drawer:open', 'open:cart-drawer',
      'cart:show', 'cart:toggle', 'theme:cart:open',
      'dispatch:cart-drawer:open', 'drawer:open',
      'shopify:cart:open'
    ];
    events.forEach(name => {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { open: true } }));
      window.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { open: true } }));
    });

    // 2. Try the global theme function that some themes expose
    try {
      if (window.theme && window.theme.cart) {
        if (typeof window.theme.cart.open === 'function') window.theme.cart.open();
        if (typeof window.theme.cart.show === 'function') window.theme.cart.show();
      }
      if (window.dispatch && typeof window.dispatch.openCartDrawer === 'function') {
        window.dispatch.openCartDrawer();
      }
      if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
    } catch (_) {}

    // 3. Click ONLY buttons (never links — they would navigate)
    const toggleSelectors = [
      'button[data-cart-drawer-toggle]',
      'button[data-drawer-toggle="cart-drawer"]',
      'button[data-action="open-cart"]',
      'button.js-drawer-open-cart',
      'button.cart-drawer-toggle',
      'button.cart-toggle',
      'button[data-drawer="cart"]',
      'button[aria-controls*="cart"][aria-expanded]'
    ];
    for (const sel of toggleSelectors) {
      const el = document.querySelector(sel);
      if (el) {
        el.click();
        return;
      }
    }

    // 4. Last resort: force-open known drawer elements via class names
    const drawerSelectors = [
      '#cart-drawer', '#CartDrawer', '.cart-drawer',
      '.drawer--cart', '#cart-popup', '.cart-popup'
    ];
    for (const sel of drawerSelectors) {
      const el = document.querySelector(sel);
      if (el) {
        el.classList.add('is-open', 'active', 'drawer--is-open', 'is-active');
        el.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cart-drawer-open', 'drawer-open', 'js-drawer-open');
        return;
      }
    }

    console.warn('[Variant Grid] No cart drawer detected. Set a custom selector in the section settings (Cart drawer selector).');
  }

  function safeClick(el) {
    if (el.tagName === 'A') {
      // Prevent navigation in case no theme listener handles it
      const stop = e => { e.preventDefault(); };
      el.addEventListener('click', stop, { capture: true, once: true });
      el.click();
    } else {
      el.click();
    }
  }
})();

  } catch(e) { console.error(e); }
})();
})();
